import { render, staticRenderFns } from "./bankHolidays.vue?vue&type=template&id=7fa197fb"
import script from "./bankHolidays.vue?vue&type=script&lang=js"
export * from "./bankHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports